import { create } from 'zustand';

interface UseCurrentCardStore {
  data: string | number | null;
  setCurrentCard: (currentCardId: string | number) => void;
  hideAllPanels: () => void;
}

export const useCurrentCardStore = create<UseCurrentCardStore>((set) => ({
  data: null,

  setCurrentCard: (currentCardId) => set({ data: currentCardId }),
  hideAllPanels: () => set({ data: null }),
}));
